import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Footer.scss';
import Banner from '../../Images/Banner.png'
import AreaData from '../../Components/ServicesPage/AreaData'

export default function Footer({ CitiePhone, WebSitePages, navigateTo }) {
    const Navigate = useNavigate()
    return (
        <div className="Footer">
            <div className="Footer2">
                <div className="Footer2Logo" onClick={() => navigateTo("")}>
                    <h1>Smith & Sons Chimney</h1>
                </div>
            </div>
            <div className="FooterTop">
                <div className="SiteMapDiv">
                    <h1>Smith & Sons Chimney</h1>
                    <div className="SiteMapDivList">
                        <a href="/">Home Page</a>
                        <a href="/services">Our Services</a>
                        <a href="/book">Schedule Online</a>
                        <a href="/contact">Contact Us</a>
                        <a href="/about">About Us</a>
                        <a href="/sitemap">Site Map</a>
                    </div>
                </div>
                <div className="SiteMapDiv">
                    <h1>Privacy</h1>
                    <div className="SiteMapDivList">
                        <a href="/privacy-policy">Privacy Policy</a>
                        <a href="/terms-and-conditions">Terms And Conditions</a>
                    </div>
                </div>
                <div className="SiteMapDiv">
                    <h1>Contact Us</h1>
                    <div className="SiteMapDivList">
                        <a target='_blank' href={`tel:${CitiePhone}`}>
                            {CitiePhone}
                        </a>
                        <a target='_blank' href="mailto:info@smithandsonschimney.com">
                            info@smithandsonschimney.com
                        </a>
                    </div>
                </div>
                <div className="SiteMapDiv">
                    <h1>Services</h1>
                    <div className="SiteMapDivList">
                        {AreaData.map((A, index) =>
                            <a key={index} href={A.Path}>{A.Title}</a>
                        )}
                    </div>
                </div>

            </div>
            <div className="Footer3">
                <h1>Copyright 2024 Smith & Sons Chimney. All rights reserved. All available services, hours of operations, pricing structure, and guarantees may vary by location.</h1>
            </div>
        </div>
    )
}
